import React,{useState,useEffect} from 'react';
import { connect } from 'react-redux';

import { Loading } from '../';

import './templateselect.css';

const TemplateSelect = ({
  userTemplates,
  userTemplatesStatus,
  onChange,
  autoSelectIf1=false // auto-select if there is only 1 template?
}) => {

  const [localValue,setLocalValue]=useState('');

  const onChangeLocal=({target:{value}})=>{
    setLocalValue(value);
    let template=userTemplates.find(elem=>elem._id===value);
    if(template) {
      template={...template};
      template._id='';
    }
    onChange(template);
  }

  useEffect(()=>{
    if(autoSelectIf1 && userTemplates.length === 1) {
      onChangeLocal({target:{value:userTemplates[0]._id}})
    }
  },[])


  let select;
  if(autoSelectIf1 && userTemplates.length === 1) {
    select=<h3 className="template-select__pre-selected">{userTemplates[0].template}</h3>
  } else {
    const options = userTemplates.map(elem => {
      const { _id, template } = elem;
      return <option key={'templ_'+_id} value={_id}>{template}</option>
    });
  
    options.unshift(<option key={'templ_'} value="">--Select--</option>);
    select=(
      <select onChange={onChangeLocal} value={localValue}>
        {options}
      </select>
    )
  }

  return (
    <div className="template-select">
      <Loading status={userTemplatesStatus} />
      {select}
    </div>
  )
}

const mapState2Props = ({ template }) => ({
  userTemplates: template.userTemplates,
  userTemplatesStatus: template.userTemplatesStatus
});

export default connect(mapState2Props)(TemplateSelect);